<template>
  <div
    ref="elRef"
    class="flex group"
    :style="{
      background:
        color && !tipoOpcao?.sim_nao_livre
          ? `rgba(${returnRGB(color)},0.1)`
          : null,
      '--color': tipoOpcao?.sim_nao_livre ? null : color,
    }"
  >
    <div
      class="Ornamento flex flex-col gap-16 px-24 py-8 w-full min-h-[--pergunta-height] h-auto border-b border-b-neutral-100/10 border-r border-neutral-100/10"
    >
      <div class="flex items-center justify-between">
        <div
          class="flex items-center gap-8 flex-nowrap w-full !mr-32"
        >
          <h2 class="text-headline-1 text-neutral-100">
            {{ title }}
          </h2>
          <div
            v-if="assessment?.exibir_pontuacao"
            class="size-24 cursor-pointer bg-neutral-100/5 rounded-lg flex-shrink-0"
          >
            <IconCoin />
            <q-tooltip v-bind="tooltipProps">
              {{ t('levelScore') }}:
              {{ alternativa.pontuacao_traduzida || 0 }}
            </q-tooltip>
          </div>
        </div>

        <q-item
          v-if="showEvidences && tipoEvidencia.alternativas"
          :clickable="!isDisabledAnexo"
          :disable="isDisabledAnexo"
          class="min-h-0 size-32 grid place-items-center rounded-[37px] border border-neutral-100/10 bg-white !p-0 absolute right-12 top-12 overflow-hidden hover:brightness-95"
          @click="
            $emit('click:evidencia', {
              evidencia: alternativa.evidencia,
              alternativa,
              pergunta,
            })
          "
        >
          <!-- fundo branco para funcionar bem a opcaidade do BG -->
          <!-- <span
            class="size-full absolute inset-0 m-auto block overflow-hidden bg-white z-0"
          /> -->
          <span
            class="size-full absolute inset-0 m-auto block overflow-hidden z-[1]"
            :style="{ background: styleIcon.background }"
          />
          <q-tooltip
            v-if="!isDisabledAnexo"
            v-bind="tooltipProps"
            :style="{
              border: `1px solid rgba(${setColorStatus(alternativa.evidencia?.status)},0.3)`,
            }"
          >
            <span
              class="absolute size-full block top-0 left-0 m-auto z-[2] overflow-hidden"
              :style="styleTooltip"
            />
            <p
              class="relative z-[3] !bg-transparent"
              :style="{ color: styleTooltip.color }"
            >
              <q-icon v-if="icon" size="1.25rem" :name="icon" />
              {{
                alternativa.evidencia?.status_traduzido ||
                t('sendEvidenceAction')
              }}
            </p>
          </q-tooltip>
          <q-icon
            size="1.5rem"
            name="svguse:#icon_anexo"
            class="relative z-[2]"
            :style="{ color: styleIcon.color }"
          />
        </q-item>
      </div>
      <TextExpandable
        v-if="description"
        :text="description"
        class="text-paragraph-3"
      />
    </div>
    <slot />
  </div>
</template>

<script setup>
import { computed, inject, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useResizeObserver } from '@vueuse/core'
import {
  tooltipProps,
  returnRGB,
  setColorStatus,
  setIconStatus,
} from 'js/utils/GLOBAL'
import usePerguntas from 'composables/usePerguntas'
import IconCoin from 'public/icons/coin.svg'
import TextExpandable from 'components/Text/TextExpandable.vue'

/** @typedef {import('js/vue/types/pergunta.ts').Alternativaset} Alternativa */

/** @type {{alternativa: Alternativa}} */
const { alternativa, assessment } = defineProps({
  color: String,
  alternativa: Object,
  title: String,
  description: String,
  tipoOpcao: Object,
  assessment: Object,
})

const {
  pergunta,
  heightAlternativa,
  isTabPrevious,
  isCorporateGroup,
  tipoEvidencia,
} = usePerguntas()

const { t } = useI18n()
const emit = defineEmits(['click:evidencia'])

const context = inject('context')
const user = context.user

const elRef = ref(null)

/** @type {{ alternativa: Alternativa }} */

function setHeight() {
  heightAlternativa.value[alternativa.id] = computed(() => {
    const h = elRef.value?.getBoundingClientRect().height
    return h ? `${h}px` : 'auto'
  })
}

const showEvidences = computed(() => {
  return (
    assessment?.exibir_evidencia &&
    pergunta.value?.necessita_evidencia
  )
})

const isDisabledAnexo = computed(() => {
  const admin = user.superuser || user.staff
  if (
    !pergunta.value?.pode_enviar_evidencia &&
    !alternativa.tem_evidencia
  ) {
    return true
  }
  if (isTabPrevious.value && !alternativa.tem_evidencia) {
    return true
  }
  if (
    (admin || isCorporateGroup.value) &&
    !alternativa.tem_evidencia
  ) {
    return true
  }
  return false
})

const styleTooltip = computed(() => {
  return {
    background: `rgba(${setColorStatus(alternativa.evidencia?.status)},0.05) !important`,
    color: `rgba(${setColorStatus(alternativa.evidencia?.status)},1)`,
    '--color1': `rgba(${setColorStatus(alternativa.evidencia?.status)},0.2)`,
  }
})

const styleIcon = computed(() => {
  return {
    color: alternativa.evidencia?.status
      ? `rgba(var(--white),1) !important`
      : `rgba(var(--icon-100),1) !important`,
    background: `rgba(${setColorStatus(alternativa.evidencia?.status)},1) !important`,
  }
})

const icon = computed(() =>
  setIconStatus(alternativa.evidencia?.status)
)

onMounted(setHeight)
useResizeObserver(elRef, setHeight)
</script>

<style lang="scss" scoped></style>

<style lang="sass" scoped>
.Ornamento
  position: relative
  &::after
    content: ''
    display: block
    position: absolute
    top: 50%
    left: 8px
    width: 3px
    border-radius: 99px
    height: calc(100% - 16px)
    transform: translateY(-50%)
    background: var(--color, rgba(218, 218, 218, 1))
</style>
